import * as types from './types';

export const loadingAnimate = (packages) => ({
  type: types.LOADING_ANIMATE,
  loadingType: packages,
});

export const declareDataFlow = (type, custom = []) => ({
  type: types.DECLARE_DATA_FLOW,
  payload: {type, custom},
});

export const checkSession = (text) => ({
  type: types.CHECK_SESSION,
  text,
});
export const getSession = (key) => ({
  type: types.GET_SESSION,
  session: key,
});

export const setArrByTheme = (key) => {
  return {
    type: types.SET_ARRAY,
    key,
  };
};
export const onSetRender = (key) => {
  return {
    type: types.SET_RENDER,
    key,
  };
};
export const getTheme = (key) => {
  return {
    type: types.GET_THEME,
    key,
  };
};
export const onSavekey = (key) => {
  return {
    type: types.SAVE_SESSION_KEY,
    key,
  };
};
export const onCollectCapture = (image) => {
  return {
    type: types.COLLECT_IMAGE,
    image,
  };
};

export const mapCollectImg = (array) => {
  return {
    type: types.MAP_IMAGES,
    array,
  };
};
export const uploadImg = (objImg) => {
  return {
    type: types.API_UPLOAD,
    objImg,
  };
};
export const onAddCapture = (image) => {
  return {
    type: types.ADD_IMAGE,
    image,
  };
};
export const onHandleReTakeArr = (retakeArray) => {
  return {
    type: types.RETAKE_ARRAY,
    retakeArray,
  };
};
export const onHandleGetDevice = (device) => {
  return {
    type: types.GET_DEVICE,
    device,
  };
};

export const deCrement = (count) => {
  return {
    type: types.DECREMENT,
    count: count--,
  };
};

export const inCrement = (count) => {
  return {
    type: types.INCREMENT,
    count: count++,
  };
};

export const resetSessionState = () => ({
  type: types.RESET_SESSION,
});

export const checkingReportDamages = (status) => {
  return {
    type: types.CHECKING_REPORT_DAMAGES,
    status,
  };
};

export const setSessionStatus = (data) => ({
  type: types.SET_SESSION_STATUS,
  data,
});

export const setInvalidWarning = (warningType) => ({
  type: types.SET_INVALID_WARNING,
  warningType,
});

export const clearInvalidWarning = () => ({
  type: types.CLEAR_INVALID_WARNING,
});
